import React from 'react';
import { Outlet } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

//import Footer from 'components/CoreContainers/Footer.js';

import styles from 'assets/jss/material-dashboard-react/layouts/adminStyle.js';

const useStyles = makeStyles(styles);

export default function MainPage({ ...rest }) {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <div className={classes.content}>
        <div className={classes.container}>
          <Outlet />
        </div>
      </div>
      {/*<Footer />*/}
    </div>
  );
};
